export const baseUrl = process.env.REACT_APP_DOCUMENTSLAYER_URL;
//export const baseUrl = "http://localhost:8003/services/documents";

export const documentslayerUrls = {
    baseUrl: () => baseUrl,
    protocol: () => `${baseUrl}/procotol`
};
